import React from "react";
import { schedule } from "../data/mockData";
import { Calendar, Clock } from "lucide-react";

const Schedule = () => {
  return (
    <div className="bg-white min-h-screen">
      {/* Page Header */}
      <div className="bg-blue-950 py-16 text-center">
        <h1 className="text-4xl sm:text-5xl md:text-6xl font-extrabold text-white mb-4 tracking-wider">
          SCHEDULE
        </h1>
        <div className="w-32 sm:w-48 h-1 bg-blue-600 mx-auto"></div>
      </div>

      <div className="max-w-6xl mx-auto px-4 sm:px-6 py-12">
        <div className="text-center mb-12">
          <p className="text-xl text-gray-700">
            Detailed schedule of TG-SMART 2026 Conference
          </p>
        </div>

        {schedule.map((day, index) => (
          <div key={index} className="mb-12">
            <div className="bg-gradient-to-r from-primary-600 to-primary-700 text-white p-6 rounded-t-xl flex items-center gap-3">
              <Calendar size={28} />
              <h2 className="text-2xl font-bold">{day.date}</h2>
            </div>

            <div className="bg-white rounded-b-xl shadow-xl overflow-hidden border-2 border-primary-100">
              <table className="w-full">
                <thead className="bg-primary-50">
                  <tr>
                    <th className="text-left p-4 text-primary-900 font-bold border-b-2 border-primary-200">
                      Time
                    </th>
                    <th className="text-left p-4 text-primary-900 font-bold border-b-2 border-primary-200">
                      Activity
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {day.events.map((event, idx) => (
                    <tr
                      key={idx}
                      className="hover:bg-primary-50 transition-colors"
                    >
                      <td className="p-4 border-b border-gray-200">
                        <div className="flex items-center gap-2 text-primary-700 font-semibold">
                          <Clock size={18} />
                          {event.time}
                        </div>
                      </td>
                      <td className="p-4 border-b border-gray-200 text-gray-700">
                        {event.activity}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        ))}

        <div className="bg-gradient-to-r from-primary-200 to-primary-300 border-blue-800 p-6 rounded-lg">
          <p className="text-black">
            <strong>Note:</strong> The schedule is tentative and subject to
            change. Please check back for updates.
          </p>
        </div>
      </div>
    </div>
  );
};

export default Schedule;
